import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-meet-clockflex',
  imports: [TranslateModule],
  templateUrl: './meet-clockflex.component.html',
  styleUrl: './meet-clockflex.component.scss',
})
export class MeetClockflexComponent {}
